import React, { FC, useState } from 'react';

import { Button } from 'devextreme-react/button';
import DataGrid, { Column, FilterRow, Pager, Paging } from 'devextreme-react/data-grid';
import 'devextreme-react/text-area';

import { AppCard, AppLayoutTop } from 'components/appComponents';

import { useGetTonarRateConfigurationListQuery } from 'bus/tonarRateConfiguration/service';

import { CreateEditModal, DeleteModal } from './components';

type Props = {
  materialId: number;
};

export const TonarRateConfiguration: FC<Props> = ({ materialId }) => {
  const [modalIsVisible, setModalIsVisible] = useState(false);
  const [detailId, setDetailId] = useState<number | null>(null);
  const [visibleDeleteModal, setVisibleDeleteModal] = useState(false);
  const { data } = useGetTonarRateConfigurationListQuery({ id: materialId });

  return (
    <div>
      <AppLayoutTop title="">
        <Button
          width={120}
          text="Создать"
          type="default"
          onClick={() => {
            setDetailId(null);
            setModalIsVisible(true);
          }}
        />
      </AppLayoutTop>

      {modalIsVisible && (
        <CreateEditModal
          changeVisible={setModalIsVisible}
          id={detailId}
          //refresh={refresh}
          visible={modalIsVisible}
          materialId={materialId}
        />
      )}
      {visibleDeleteModal && (
        <DeleteModal changeVisible={setVisibleDeleteModal} id={detailId} visible={visibleDeleteModal} />
      )}

      <AppCard>
        <DataGrid
          dataSource={data}
          showBorders={false}
          loadPanel={{
            enabled: true,
            text: 'Загрузка',
          }}
          remoteOperations={true}
        >
          <FilterRow visible={true} />

          <Column dataField="factoryName" caption="Площадка" />
          <Column dataField="rate" caption="Коэффициент" />
          <Column dataField="dateBegin" caption="Дата начала" dataType="date" />
          <Column dataField="dateEnd" caption="Дата окончания" dataType="date" />

          <Column
            dataField="actions"
            caption=""
            width={120}
            allowFiltering={false}
            allowSorting={false}
            cellRender={(data) => (
              <>
                <Button
                  icon="edit"
                  type="default"
                  stylingMode="text"
                  onClick={() => {
                    setDetailId(data.data.id);
                    setModalIsVisible(true);
                  }}
                />
                <Button
                  icon="trash"
                  type="default"
                  stylingMode="text"
                  onClick={() => {
                    setVisibleDeleteModal(true);
                    setDetailId(data.data.id);
                  }}
                />
              </>
            )}
          />

          <Paging defaultPageSize={15} />
          <Pager showPageSizeSelector={true} allowedPageSizes={[15, 30, 50, 100]} />
        </DataGrid>
      </AppCard>
    </div>
  );
};
